var _module = require('./index');
var states = require('./states');
var _ = require('lodash');
require('../events');

_module.controller('LocalHousingMarketCtrl', [
    '$anchorScroll',
    '$location',
    '$events',
    '$listing',
    '$timeout',
    '$log',
    '$filter',
    function($anchorScroll, $location, $events, $listing, $timeout, $log, $filter) {
        const vm = this;
        vm.model = {
            stats: {},
        };

        vm.services = {
            formatStatsValue: function (val) {
                return formatStatsValue.apply(vm, [val, $filter]);
            },
        };

        function init() {
            if(vm.report && vm.report.address) {
                $listing.getLocalHousingMarketStats(vm.report.address)
                    .then(function (stats) {
                        $timeout(function () {
                            vm.model.stats.medianPrice = vm.services.formatStatsValue(_.get(stats, 'median_price'));
                            vm.model.stats.activeListingsCount = vm.services.formatStatsValue(_.get(stats, 'counts.active_listings'));
                            vm.model.stats.newListingsCount = vm.services.formatStatsValue(_.get(stats, 'counts.new'));
                            vm.model.stats.medianDOM = vm.services.formatStatsValue(_.get(stats, 'median_dom'));
                        });
                    })
                    .catch(function (err) {
                        $log.error(err);
                    });
            }
        }

        init();
    }
]);

function formatStatsValue(val, $filter) {
    const value = val || null;
    var formattedValue = value;
    if(value) {
        if(!isNaN(parseInt(value, 10)) && parseInt(value, 10) > 1000000) {
            formattedValue = $filter('numberAbbreviate')(value);
        } else {
            formattedValue = $filter('addCommasToNumber')(value);
        }
    }
    return formattedValue || '-';
}

_module.directive('localHousingMarket', [
    function() {
        return {
            scope: {
                report: '=',
                isMobile: '=',
                cardsResponsiveBreakpoints: '='
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: 'LocalHousingMarketCtrl',
            restrict: 'E',
            templateUrl: 'js/components/modals/templates/local-housing-market.tmpl.html'
        };
    }
]);
